/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import { DocumentWindow }            from './document.window';
import { DocumentWindowManager }     from './document.window.manager';
import { Logger }                    from '@/util/logger';

import { BlobService }               from '@/services/blob.service';
import { AuthenticationService}      from '@/services/authentication.service';
import { IdeService}                 from '@/services/ide.service';
import { JobsViewerMetadata }        from './jobs.viewer.metadata';

import { JobsViewerComponent }       from '@/components/jobs.viewer.component';

import * as $                        from 'jquery';
import 'gasparesganga-jquery-loading-overlay'; /* https://gasparesganga.com/labs/jquery-loading-overlay/ */

import {ComponentFactoryResolver, EmbeddedViewRef, ViewContainerRef} from "@angular/core";
import {ResizeObserver} from "resize-observer";


/**
 *
 * @class JobsViewerWindow
 *
 * @brief window for viewing all jobs (regardless of status) for this project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class JobsViewerWindow extends DocumentWindow {

  /** access to the virtual file system */
  private blobber:           BlobService = null;

  /** access to user authentication */
  private auth:    AuthenticationService = null;

  /** access to user authentication */
  private ide:                IdeService = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the current job in focus */
  private focus:                 string = '';

  /** the actual editor */
  private viewer:   JobsViewerComponent = null;

  /** standard constructor */
  constructor(
    meta: JobsViewerMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[JobsViewWindow] constructing...');

    this.manager     = manager;
    this.auth        = this.manager.authService();
    this.blobber     = this.manager.blobService();
    this.ide         = this.manager.ideService();
    this.focus         = meta.focus;

    this.showViewer();
  }

  /** restore the search view (on current 'focus') */
  public showViewer() {

    Logger.debug(`[JobsViewerWindow] => ${this.focus} ...`);

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[JobsViewerWindow] missing hosting container (${this.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="jobs_viewer_${this.meta.id}" class="">
</div>
`);

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`jobs_viewer_${this.meta.id}`) as HTMLElement;

      if (dom) {

        clearInterval(checkExist);

        $(dom).css('height', '100%');

        Logger.debug(`[JobsViewerWindow] init ...`);

        const    view: ViewContainerRef         = this.ide.view;
        const factory: ComponentFactoryResolver = this.ide.componentResolver;


        const creator      = factory.resolveComponentFactory(JobsViewerComponent);
        const componentRef = view.createComponent(creator);

        this.viewer        = componentRef.instance  as JobsViewerComponent;

        const domElem      = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        /* ensure the new component is parented under our container */

        dom.appendChild(domElem);

        /*
         * add a self watch for changes in wrapper size...because sometime it will change because
         * the panels around it have changed in size...not because the browser has changed in size;
         * that is, its not a window resize event, so that kind of size change wouldn't normally
         * be caught.
         *
         */
        const resizeObserver = new ResizeObserver(entries => {

          this.viewer.resize();
        });

        resizeObserver.observe( dom );

        /*  can now use 'viewer' as usual ... */

      }

    }, 100);
  }

  /** update the focus to current */
  private updateFocus(focus: string) {

    this.focus  = focus;

    let keyBase = focus.substring(focus.lastIndexOf('/') + 1);

    if(!keyBase || keyBase === '' ) {

      keyBase = focus;
    }

    this.title  = `${keyBase}`;

    this.viewer.focus();
  }

}
